import {
	IFullQuestion,
	IQuestion,
	IShortQuestion,
} from "@tests-core/schemas/questions/helper-schemas";
import { PseudoRandom } from "@tests-core/utils/shuffle";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { IRFolder, ItemType } from "./api/folders/helper-schemas";
import { IRGETFolderItemsRecursively } from "./api/folders/validators";
import { IRTest } from "./api/tests/helper-schemas";
import { inject } from "./modules";
import { NotUndefined, ObjectId } from "./utils/generics";

export function addLoader() {
	const loaderDiv = document.createElement("div");
	loaderDiv.setAttribute("class", "loaderDiv");
	ReactDOM.render(
		<div className="loaderChild" />,
		document.body.appendChild(loaderDiv)
	);
	return () => {
		if (
			typeof loaderDiv.parentNode !== "undefined" &&
			loaderDiv.parentNode !== null
		) {
			loaderDiv.parentNode.removeChild(loaderDiv);
		}
	};
}

function toGeorgianOrdinalNumber(num: number, mode?: 0 | 1 | 2): string {
	// რიგითობაში
	if (num === 1) {
		if (typeof mode === "undefined") return "I";
		if (mode === 0) return "1-ლი";
		if (mode === 1) return "1-ელ";
		return "1-ელმა";
	}
	if (
		num <= 20 ||
		(num <= 100 && num % 20 === 0) ||
		(num <= 1000 && num % 100 === 0)
	)
		return "მე-" + num;
	return num + "-ე";
}

export function romanize(num: number): string {
	const lookup: any = {
		M: 1000,
		CM: 900,
		D: 500,
		CD: 400,
		C: 100,
		XC: 90,
		L: 50,
		XL: 40,
		X: 10,
		IX: 9,
		V: 5,
		IV: 4,
		I: 1,
	};
	let roman = "";
	for (const i in lookup) {
		if (lookup.hasOwnProperty(i)) {
			while (num >= lookup[i]) {
				roman += i;
				num -= lookup[i];
			}
		}
	}
	return roman;
}

export function toDecadeNames(decade: number, century: number): string {
	if (decade === 0) return toDecadeNames(century * 100, century + 1);
	return decade + "იანი";
}

export { toGeorgianOrdinalNumber };
export { _console };
export { weekDaysGeo, weekDaysAbbrGeo, weekDaysGeoNatesaobiti, monthNamesGeo };
export { funcToPromise };
export { animateWindowScroll };
export { getQueryStringParams };
export { cities, fields, sectors };

const _console: { log: Function; error: Function } = {
	log: (...args) => {
		// tslint:disable-next-line
		console.log(...args);
	},
	error: (...args) => {
		// tslint:disable-next-line
		console.error(...args);
	},
};

const weekDaysGeo: string[] = [
	"ორშაბათი",
	"სამშაბათი",
	"ოთხშაბათი",
	"ხუთშაბათი",
	"პარასკევი",
	"შაბათი",
	"კვირა",
];
const weekDaysAbbrGeo: string[] = [
	"ორშ",
	"სამ",
	"ოთხ",
	"ხუთ",
	"პარ",
	"შაბ",
	"კვ",
];
// tslint:disable-next-line
const weekDaysGeoNatesaobiti: string[] = [
	"ორშაბათის",
	"სამშაბათის",
	"ოთხშაბათის",
	"ხუთშაბათის",
	"პარასკევის",
	"შაბათის",
	"კვირის",
];
// tslint:disable-next-line
const monthNamesGeo = [
	"იანვარი",
	"თებერვალი",
	"მარტი",
	"აპრილი",
	"მაისი",
	"ივნისი",
	"ივლისი",
	"აგვისტო",
	"სექტემბერი",
	"ოქტომბერი",
	"ნოემბერი",
	"დეკემბერი",
];

const funcToPromise = (func: Function) =>
	new Promise((resolve, reject) => {
		try {
			resolve(func());
		} catch (e) {
			reject();
		}
	});

export const animateHTMLElement = (
	element: HTMLElement,
	propertyName: string,
	endPosition: number,
	duration: number
) => {
	const startPosition = element[propertyName];
	const startTime = performance.now();
	const animate = () => {
		const percentage = Math.min(
			1,
			(performance.now() - startTime) / duration
		);
		element.scrollTo(
			0,
			percentage * (endPosition - startPosition) + startPosition
		);
		if (percentage < 1) window.requestAnimationFrame(animate);
	};
	window.requestAnimationFrame(animate);
};

const animateWindowScroll = (whereToScrollTop: number, duration: number) => {
	const scrollTop = window.pageYOffset || document.documentElement!.scrollTop;
	const startTime = performance.now();
	const animateScroll = () => {
		const percentage = Math.min(
			1,
			(performance.now() - startTime) / duration
		);
		window.scrollTo(
			0,
			percentage * (whereToScrollTop - scrollTop) + scrollTop
		);
		if (percentage < 1) window.requestAnimationFrame(animateScroll);
	};
	window.requestAnimationFrame(animateScroll);
};

const getQueryStringParams = (query: string): { [key: string]: string } =>
	query
		? (/^[?#]/.test(query) ? query.slice(1) : query)
				.split("&")
				.reduce((params, param) => {
					const [key, value] = param.split("=");
					params[key] = value
						? decodeURIComponent(value.replace(/\+/g, " "))
						: "";
					return params;
				}, {})
		: {};

const cities = [
	{ id: 1, name: "თბილისი" },
	{ id: 2, name: "ქუთაისი" },
	{ id: 3, name: "ბათუმი" },
	{ id: 4, name: "რუსთავი" },
	{ id: 5, name: "ზუგდიდი" },
	{ id: 6, name: "გორი" },
	{ id: 8, name: "ახალციხე" },
	{ id: 10, name: "თელავი" },
	{ id: 17, name: "ახალქალაქი" },
];
const fields = [
	{ id: 1, name: "სოციალური და პოლიტიკური" },
	{ id: 2, name: "ჰუმანიტარული" },
	{ id: 3, name: "ტექნიკური" },
	{ id: 4, name: "ზუსტი და საბუნებისმეტყველო" },
	{ id: 5, name: "იურიდიული" },
	{ id: 6, name: "ბიზნესი და ეკონომიკა" },
	{ id: 7, name: "სამედიცინო" },
	{ id: 8, name: "სახელოვნებო" },
];
const sectors = ["სახელმწიფო", "კერძო"];

export const foreignLanguages = [
	{ id: "ENG", name: "ინგლისური" },
	{ id: "RUS", name: "რუსული" },
	{ id: "DEU", name: "გერმანული" },
	{ id: "FRA", name: "ფრანგული" },
];

export const shortenName = (name: string, maxLength: number = 75): string => {
	return name.length <= maxLength
		? name
		: name.substr(0, maxLength - 2).trim() + "..";
};

export function getHTMLElementCoords(elem: HTMLElement) {
	// crossbrowser version
	const box = elem.getBoundingClientRect();

	const body = document.body;
	const docEl = document.documentElement;

	const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
	const scrollLeft =
		window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

	const clientTop = docEl.clientTop || body.clientTop || 0;
	const clientLeft = docEl.clientLeft || body.clientLeft || 0;

	const top = box.top + scrollTop - clientTop;
	const left = box.left + scrollLeft - clientLeft;

	return { top, left };
}
(window as any).getHTMLElementCoords = getHTMLElementCoords;

export function extractVideoIdFromYoutubeLink(link: string): string {
	if (link.indexOf("youtu.be") >= 0) {
		const endIndex = link.indexOf("?");
		return link.substring(
			link.lastIndexOf("/") + 1,
			endIndex > -1 ? endIndex : undefined
		);
	}
	if (link.indexOf("youtube") >= 0) {
		const endIndex = link.indexOf("&");
		return link.substring(
			link.indexOf("=") + 1,
			endIndex > -1 ? endIndex : undefined
		);
	}
	return "";
}

export function getVideoThumbNailUrl(videoLink: string): string {
	const youtubeVideoId = extractVideoIdFromYoutubeLink(videoLink);
	return `https://img.youtube.com/vi/${youtubeVideoId}/0.jpg`;
}

export const getGalleryMediaUrl = (
	type: "PHOTO" | "VIDEO",
	url: string
): string => {
	if (type === "PHOTO") {
		return `/photos/gallery/${url}`;
	}
	return getVideoThumbNailUrl(url);
};

export const getNewsOrEventMediaUrl = (
	type: "PHOTO" | "VIDEO",
	url: string
): string => {
	if (type === "PHOTO") {
		return `/photos/etc/${url}`;
	}
	return getVideoThumbNailUrl(url);
};

export const round = (num: number, precision: number = 0): number => {
	if (precision < 0) return -1;
	const numString = String(num);
	const decimalPointIndex = numString.indexOf(".");
	if (decimalPointIndex < 0) return num;
	if (numString.length - decimalPointIndex - 1 <= precision) return num;
	const leastSignificantDigit = Number(
		numString.charAt(decimalPointIndex + precision + 1)
	);
	const lastDigitPosition =
		precision > 0 ? decimalPointIndex + precision : decimalPointIndex - 1;
	let lastDigit = Number(numString.charAt(lastDigitPosition));
	if (leastSignificantDigit >= 5) lastDigit++;
	const newString = numString.substring(0, lastDigitPosition) + lastDigit;
	return Number(newString);
};

export const getFirstQuestion = (
	questions: (IFullQuestion | IShortQuestion)[],
	test: IRTest
): ObjectId => {
	const questionIds = questions.map(q => q._id);
	if (test.settings && test.settings.isContentSorted) return questionIds[0];
	return questionIds[Math.floor(Math.random() * questionIds.length)];
};

export const getNextQuestion = (
	questions: (IFullQuestion | IShortQuestion)[],
	answeredQuestions: ObjectId[],
	test: IRTest
): { id: ObjectId; isFinished: false } | { isFinished: true } => {
	const questionIds = questions.map(q => q._id);
	const nonAnsweredQuestions = questionIds.filter(
		id => answeredQuestions.indexOf(id) < 0
	);
	if (nonAnsweredQuestions.length === 0) {
		return {
			isFinished: true,
		};
	}
	let index = Math.floor(Math.random() * nonAnsweredQuestions.length);
	if (test.settings && test.settings.isContentSorted) {
		index = 0;
	}
	return {
		id: nonAnsweredQuestions[index],
		isFinished: false,
	};
};

export const filterQuestions = (
	questions: NotUndefined<IRGETFolderItemsRecursively["questions"]>,
	folderId: ObjectId,
	testTypeId: ObjectId
): IQuestion[] => {
	const Folder = inject("FolderModel");
	const folder = Folder.findByIdSync(folderId);
	if (!folder) return [];
	let questionIds: ObjectId[] = [];
	getQuestionsForTestType(folder, questionIds, testTypeId);
	questionIds = [...new Set(questionIds)];
	const newQuestions: IQuestion[] = [];
	for (let i = 0; i < questionIds.length; i++) {
		// FIXME: add getAnswers to IAGETFolderItemsRecursively
		if (questions[questionIds[i]])
			newQuestions.push(questions[questionIds[i]]! as IQuestion);
	}
	return newQuestions;
};

const getQuestionsForTestType = (
	folder: IRFolder,
	questionIds: ObjectId[],
	testTypeId: ObjectId
): void => {
	if (!folder) return;
	if (!folder.items) return;
	const Folder = inject("FolderModel");
	const childForderIds: ObjectId[] = [];
	for (let i = 0; i < folder.items.length; ++i) {
		const item = folder.items[i];
		if (item.type === ItemType.folder) {
			childForderIds.push(item.id);
		} else if (item.type === ItemType.question) {
			questionIds.push(item.id);
		}
	}
	const childFolders = Folder.findManyByIdsSync(childForderIds);

	for (let i = 0; i < childFolders.length; ++i) {
		const childFolder = childFolders[i];
		getQuestionsForTestType(childFolder, questionIds, testTypeId);
	}
};

export function getRandomColor(key?: number) {
	const Rand = new PseudoRandom(
		key === undefined ? Math.floor(Math.random() * 1e6) : key
	);
	const letters = "3456789ABC";
	let color = "#";
	for (let i = 0; i < 6; i++) {
		color += letters[Rand.nextInt() % letters.length];
	}
	return color;
}

export const reactSelectStyles = {
	container: styles => ({
		...styles,
		zIndex: "auto",
	}),
	menu: styles => ({
		...styles,
		zIndex: 9999,
	}),
};

export enum HierarchicItemType {
	Folder = 1,
	Topic = 2,
	TaskType = 3,
}
